import React from "react";
import qualityServiceImg from "../../images/pharmacy-2.jpeg";
import teeth1 from "../../images/teeth1.jpg";
const QualityService = () => {
  return (
    <>
      <div className="container lg:flex py-16">
        <div className="h-full lg:w-2/3 w-full">
          <img className="w-full" src={qualityServiceImg} alt="" />
        </div>
        <div className="lg:ml-8">
          <h1 className="text-3xl font-Poppins font-semibold">
            10 vjet shërbim cilësor në{" "}
            <span className="text-primary">Praktikë dentare</span>
          </h1>
          <p className="py-8">
            Ne krenohemi shumë me
            cilësinë e punës sonë. Ne e kuptojmë se çfarë klienti i plotë
            kënaqësi do të thotë kënaqësi e klientit.{" "}
          </p>
          <div className="lg:flex justify-between">
            <ul>
              <li className="flex">
                <i className="far fa-hand-point-right text-3xl text-green-500"></i>
                <h1 className="text-lg pb-8 px-4 uppercase font-bold leading-snug text-black hover:opacity-75">
                  Staf i kualifikuar
                </h1>
              </li>
              <li className="flex">
                <i className="far fa-hand-point-right text-3xl text-green-500"></i>
                <h1 className="text-lg pb-8 px-4 uppercase font-bold leading-snug text-black hover:opacity-75">
                  Ne ofrojmë trajtim cilësor
                </h1>
              </li>
              <li className="flex">
                <i className="far fa-hand-point-right text-3xl text-green-500"></i>
                <h1 className="text-lg pb-8 px-4 uppercase font-bold leading-snug text-black hover:opacity-75">
                  Çmime konkuruese
                </h1>
              </li>
            </ul>
            <div>
              <img src={teeth1} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QualityService;
